import styled from 'styled-components';
import { DndContext, KeyboardSensor, PointerSensor, closestCenter, useSensor, useSensors } from '@dnd-kit/core';
import {
  SortableContext,
  arrayMove,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { BranchPrioritySection } from './BranchPrioritySection';
import { useCallback } from 'react';
import { useOnBranchesOrganised } from '../hooks/useOnBranchesOrganised';
import { NodeIds } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/utils/NodeTypeKeys';
import { useWorkFlowCanvas } from '../../../../contexts/CampaignFlowProvider';

const PriorityLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.designToken.spacing4};
`;

export const Branches = ({ branches }) => {
  const organiseBranches = useOnBranchesOrganised();
  const { state } = useWorkFlowCanvas();

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  const onSorted = useCallback(
    event => {
      const { active: branchPrioritySection, over: targetPriorityToReplace } = event;

      const hasBeenMovedToNewPriority = branchPrioritySection.id !== targetPriorityToReplace.id;
      if (hasBeenMovedToNewPriority) {
        const controlNode = state.nodes.find(s => s.id === NodeIds.branchControl);
        const branchNameNodeIds = state.nodes.filter(s => controlNode.data.children.includes(s.id)).map(s => s.id);
        const oldIndex = branchNameNodeIds.indexOf(branchPrioritySection.id);
        const newIndex = branchNameNodeIds.indexOf(targetPriorityToReplace.id);
        const orderedArray = arrayMove(branchNameNodeIds, oldIndex, newIndex);

        organiseBranches(NodeIds.branchControl, orderedArray);
      }
    },
    [organiseBranches, state.nodes],
  );

  return (
    <PriorityLayout>
      <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={onSorted}>
        <SortableContext items={branches} strategy={verticalListSortingStrategy}>
          {branches.map(({ id, name }, i) => (
            <BranchPrioritySection key={id} priority={i + 1} id={id} name={name} />
          ))}
        </SortableContext>
      </DndContext>
    </PriorityLayout>
  );
};
